<template>
  <el-dialog
      title="传输日志明细"
      :visible.sync="visible"
      width="60%"
      @close="close"
  >
    <el-form :model="form" :inline="true" ref="form" label-width="130px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="主键id：" prop="id">
            {{ form.id }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="第三方名称：" prop="thirdName">
            {{ form.thirdName }}
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="节点名称：" prop="flowNodeName">
            {{ form.flowNodeName }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="日志类型：" prop="logName">
            {{ form.logName }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="业务id：" prop="businessId">
            {{ form.businessId }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="动作：" prop="action">
            {{ form.action }}
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="12">
          <el-form-item label="创建时间：" prop="createTime">
            {{ form.createTime }}
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="更改时间：" prop="updateTime">
            {{ form.updateTime }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="传输结果：" prop="result">
            <el-input type="textarea" :rows="4" v-model="form.result" style="width: 600px;"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24">
          <el-form-item label="数据：" prop="data">
            <el-input type="textarea" :rows="20" v-model="form.data" style="width: 600px;"/>
          </el-form-item>
        </el-col>
      </el-row>



    </el-form>
    <template #footer>
      <el-button @click="resetPush">重推</el-button>
      <el-button @click="close">取 消</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "SysTransLogsDetail",
  props: ['mainContentViewHeight'],
  data() {
    return {
      visible: false,
      form: {},
    }
  },
  methods: {
    show(row) {
      this.form = Object.assign({}, row)
      this.visible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.visible = false
    },
    resetPush(){
      this.$emit('repush',this.form)
    }
  }
}
</script>
